/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "16f90ec62c10c34b3c83b31e98756e8df55b4ca8";
